export default function PlayerSlot({ player, onClick }) {
  const isGK = player?.position === "Goalkeeper";

  return (
    <div className="player-slot" onClick={onClick}>
      <div className={`shirt ${isGK ? "shirt-gk" : ""}`}>
        <span className="shirt-number">
          {player?.shirtNumber ?? ""}
        </span>
      </div>

      <div className="player-name">
        {player ? player.name : "Empty"}
      </div>
    </div>
  );
}
